import { connect } from "react-redux";
import * as Nested from "@/util/Nested";
import CustomerSearchPage from "./CustomerSearchPage";
import * as CriteriaForm from "./CriteriaForm.state";
import customerSearchReducer, {
  mapStateToProps as customerSearchMapState,
  mapDispatchToProps as customerSearchMapDispatch,
} from "./CustomerSearchPage.state";

const {
  reducer: nestedReducer,
  mapStateToProps,
  mapDispatchToProps,
  actions,
} = Nested.nestStates(
  {
    reducer: customerSearchReducer,
    mapStateToProps: customerSearchMapState,
    mapDispatchToProps: customerSearchMapDispatch,
  },
  {
    forms: {
      criteriaForm: {
        ...CriteriaForm,
        actionType: "CUSTOMER_SEARCH_CRITERIA_FORM_ACTION",
      },
    },
  },
  "customerSearch"
);

const reducer = (state, action) => nestedReducer(state, action);

export { reducer, mapStateToProps, mapDispatchToProps, actions };

export default connect(mapStateToProps, mapDispatchToProps)(CustomerSearchPage);
